import { createRoot } from 'react-dom/client'
// Axios
import { QueryClient, QueryClientProvider } from 'react-query'
// Apps
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
**/
import './_metronic/assets/css/style.rtl.css'
import './_metronic/assets/custom.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import { AppRoutes } from './app/routing/AppRoutes'
import { AuthProvider } from './app/modules/auth'
import { BrowserRouter } from 'react-router-dom'
import LoadingContextProvider from './app/core/context/loading/loading'
import PushContextProvider from './app/core/context/push/push'
import { register as registerServiceWorker } from './serviceWorkerRegistration'


const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <BrowserRouter>
      <LoadingContextProvider>
        <MetronicI18nProvider>
          <AuthProvider>
            <PushContextProvider>
              <QueryClientProvider client={queryClient}>
                <AppRoutes />
              </QueryClientProvider>
            </PushContextProvider>
          </AuthProvider>
        </MetronicI18nProvider>
      </LoadingContextProvider>
    </BrowserRouter>
  )
}
registerServiceWorker()
